// Bảng theo ngày: cột gọn, số căn phải; nhiệm vụ gom "xong/nhận" mỗi ô; nguồn Xu hiện khi mở rộng dòng.
import { Card, Table } from "antd";
import { fmtNum, fmtVnDate, missionKeys, missionName, sourceLabel } from "./xu-format-helpers";

const mission = (k, titles) => ({
    title: missionName(k, titles),
    align: "right",
    render: (_, r) => <span>{fmtNum(r.missions[k]?.completed || 0)}<span className="text-gray-400"> / {fmtNum(r.missions[k]?.claimed || 0)}</span></span>,
});

const columns = [
    { title: "Ngày", dataIndex: "vnDate", render: fmtVnDate, fixed: "left", width: 100 },
    { title: "Điểm danh", dataIndex: "checkins", align: "right", render: fmtNum },
    { title: "Xu phát", dataIndex: "earned", align: "right", render: fmtNum },
    { title: "Thu hồi", dataIndex: "revoked", align: "right", render: (v) => (v ? <span className="text-red-500">{fmtNum(v)}</span> : "—") },
];

export default function XuStatsDailyTable({ days, loading, missionTitles = {} }) {
    const cols = [...columns, ...missionKeys(days, missionTitles).map((k) => mission(k, missionTitles))];
    return (
        <Card size="small" title="Chi tiết từng ngày" className="shadow-sm"
            extra={<span className="text-xs text-gray-400">Nhiệm vụ: xong / đã nhận · bấm dấu + để xem nguồn Xu</span>}>
            <Table
                size="small"
                rowKey="vnDate"
                columns={cols}
                dataSource={[...days].reverse()}
                loading={loading}
                pagination={days.length > 15 ? { pageSize: 15, showSizeChanger: false } : false}
                scroll={{ x: "max-content" }}
                expandable={{
                    rowExpandable: (r) => Object.keys(r.earnBySource).length > 0,
                    expandedRowRender: (r) => Object.entries(r.earnBySource).map(([s, v]) => `${sourceLabel(s)}: ${fmtNum(v)} Xu`).join(" · "),
                }}
            />
        </Card>
    );
}
